export default "__VITE_ASSET__td01yS05__"